<div class="container panel" #container>
  <div class="form-field">

    <ng-container [ngSwitch]="type">

      <!-- Custom input types -->

      <ng-container *ngSwitchCase="'options'">
        <div *ngIf="!useComboBox" class="form-field" [ngClass]="{ 'clickable': !disabled }" (click)="openOptionsDialog()">
          <mat-form-field appearance="fill">
            <mat-label>{{ label }}</mat-label>
            <input #child readonly matInput type="text" [disabled]="disabled" [value]="getOptionDisplayValue(value)" />
            <mat-icon matSuffix class="more-icon" *ngIf="!disabled">chevron_right</mat-icon>
          </mat-form-field>
        </div>

        <div *ngIf="useComboBox" class="form-field" [ngClass]="{ 'clickable': !disabled }">
          <mat-form-field appearance="fill">
            <mat-label>{{ label }}</mat-label>
            <mat-select #child [value]="value" (selectionChange)="onChildChange(child.value)">
              @for (option of getResolvedOptions(); track option.value; let last = $last) {
              <mat-option [value]="option.value" [disabled]="option.disabled">
                {{ option.displayText }}
              </mat-option>
              <mat-divider *ngIf="!last"></mat-divider>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'multipleOptions'">
        <div class="form-field" [ngClass]="{ 'clickable': !disabled }">
          <mat-form-field appearance="fill">
            <mat-label>{{ label }}</mat-label>
            <mat-select #child [value]="value" multiple (selectionChange)="onChildChange(child.value)">
              @for (option of getResolvedOptions(); track option.value; let last = $last) {
              <mat-option [value]="option.value" [disabled]="option.disabled">
                {{ option.displayText }}
              </mat-option>
              <mat-divider *ngIf="!last"></mat-divider>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'menu'">
        <div class="form-field" [ngClass]="{ 'clickable': !disabled }">
          <mat-form-field appearance="fill">
            <mat-label>{{ label }}</mat-label>
            <input #child readonly matInput type="text" [disabled]="disabled" [value]="value" />
            <mat-icon class="more-icon" matSuffix *ngIf="!disabled">chevron_right</mat-icon>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'switch'">
        <ng-container [ngSwitch]="disabled">
          <ng-container *ngSwitchCase="true">
            <div class="form-field">
              <mat-form-field appearance="fill">
                <mat-label>{{ label }}</mat-label>
                <input #child matInput type="text"
                  [value]=" (value ? ('General.Enabled' | translate) : ('General.Disabled' | translate))"
                  [disabled]="disabled" (change)="onChildChange(child.value)" (input)="onChildInput(child.value)" />
              </mat-form-field>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="false">
            <div [ngClass]="{ 'disabled-custom': disabled }" class="switch-field">
              <div class="switch-field-left">
                <mat-label>{{ label }}</mat-label>
              </div>
              <div class="switch-field-right">
                <label class="switch">
                  <input #child type="checkbox" [checked]="value" [disabled]="disabled"
                    (change)="onChildChange(child.checked)" (input)="onChildInput(child.checked)">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </ng-container>

        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="'slider'">
        <div [ngClass]="{ 'disabled-custom': disabled }" class="vcenter full-width-slider">
          <div class="slider-title-container">
            <div class="item-title truncate">{{ label }}</div>
            <div class="item-title truncate">{{ value }}</div>
          </div>
          <app-slider #child [disabled]="disabled" [min]="min" [max]="max" [step]="step" [value]="value"
            [logarithmic]="logarithmic" [leftIcon]="leftIcon" [rightIcon]="rightIcon"
            (input)="onChildInput(child.value)" (change)="onChildChange(child.value)">
          </app-slider>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'number'">
        <div class="form-field">
          <mat-form-field appearance="fill">
            <mat-label>{{ label }}</mat-label>
            <input #child matInput type="number" [value]="value" [disabled]="disabled" [min]="min" [max]="max"
              (change)="onChildChange(child.value)" (input)="onChildInput(child.value)" (focus)="onFocus($event)"
              (blur)="onFocus()" />

            <button type="button" class="button-class" *ngIf="showEmptyButton()" matSuffix mat-icon-button
              aria-label="Clear" (click)="emptyValue()" tabindex="-1">
              <mat-icon>highlight_off</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'text'">
        <div class="form-field">
          <mat-form-field appearance="fill">
            <mat-label>{{ label }}</mat-label>
            <input #child matInput type="text" [value]="value" [disabled]="disabled" [minLength]="minLength"
              [maxLength]="maxLength" (change)="onChildChange(child.value)" (focus)="onFocus()" (blur)="onFocus()"
              (input)="onChildInput(child.value)" [matAutocomplete]="auto" />

            <button type="button" class="button-class" *ngIf="showEmptyButton()" matSuffix mat-icon-button
              aria-label="Clear" (click)="emptyValue()" tabindex="-1">
              <mat-icon>highlight_off</mat-icon>
            </button>

            <button type="button" class="button-class" mat-icon-button matSuffix
              (click)="onSuffixIconClicked($event)" *ngIf="suffixIcon" tabindex="-1">
              <mat-icon>{{ suffixIcon }}</mat-icon>
            </button>

            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let item of autoCompleteOptions$ | async let last = last" [value]="item"
                (click)="onChildInput(item)">
                {{ item }}
                <mat-divider *ngIf="!last"></mat-divider>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'password'">
        <div class="form-field">
          <mat-form-field appearance="fill">
            <mat-label>{{ label }}</mat-label>
            <input #child matInput [type]="passwordType" [value]="value" [disabled]="disabled" [minLength]="minLength"
              [maxLength]="maxLength" (change)="onChildChange(child.value)" (focus)="onFocus()" (blur)="onFocus()"
              (input)="onChildInput(child.value)" />

              <button type="button" class="button-class" *ngIf="showToggleVisibilityButton()" matSuffix mat-icon-button
                (click)="toggleVisibilityPassword()" tabindex="-1">
              <mat-icon>{{ showPassWord ? "visibility_off" : "visibility"}}</mat-icon>
            </button>

          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'date'">
        <div class="form-field">
          <mat-form-field appearance="fill">
            <mat-label>{{ label }}</mat-label>
            <input #child matInput type="date" [value]="value" [disabled]="disabled" max="{{maxDate}}" min="{{minDate}}"
              (change)="onChildChange(child.value)" (input)="onChildInput(child.value)" (focus)="onFocus($event)"
              (blur)="onFocus()" />
      
            <button type="button" class="button-class" *ngIf="showEmptyButton()" matSuffix mat-icon-button
              aria-label="Clear"  (click)="emptyValue()" tabindex="-1">
              <mat-icon>highlight_off</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </ng-container>

      <!-- Any other types are just basic mat-inputs -->
      <ng-container *ngSwitchDefault>
        <!-- This just creates a basic input with the type passed as the mat-input type attribute -->
        <ng-container *ngTemplateOutlet="basicInput; context: {type: type}"></ng-container>
      </ng-container>

    </ng-container>

  </div>

  <ng-container *ngIf="info">
    <div class="info">{{ info }}</div>
  </ng-container>
</div>

<ng-template #basicInput let-type='type'>
  <div class="form-field">
    <mat-form-field appearance="fill">
      <mat-label>{{ label }}</mat-label>
      <input #child matInput type="{{ type }}" [value]="value" [disabled]="disabled"
        (change)="onChildChange(child.value)" (input)="onChildInput(child.value)" (focus)="onFocus($event)"
        (blur)="onFocus()" />

      <button type="button" class="button-class" *ngIf="showEmptyButton()" matSuffix mat-icon-button
        aria-label="Clear" (click)="emptyValue()" tabindex="-1">
        <mat-icon>highlight_off</mat-icon>
      </button>
    </mat-form-field>
  </div>
</ng-template>
